
import { useState } from "react";
import styles from "../HealthChat.module.css";

const VISIT_MODELS = [
  {
    id: "clinic",
    label: "In-clinic visit",
    icon: "🏥",
    badge: null,
    type: "emoji",
  },
  {
    id: "video",
    label: "Video consultation",
    icon: "💻",
    badge: "Video consultation available today",
    recommended: true,
    type: "emoji",

  },
  {
    id: "chat",
    label: "Chat consultation",
    icon: "/images/chatbotFemCare.svg",
    badge: null,
    type: "image",
  },
];

export default function SelectVisitModelScreen({ onSelect, onBack }) {
  const [selected, setSelected] = useState("video");

  return (
    <div className={styles.visitModelScreen}>
      <button className={styles.visitModelBack} onClick={onBack}>← Back</button>
      <div className={styles.visitModelTitle}>Select Visit Model</div>

      <div className={styles.visitModelRow}>
        {VISIT_MODELS.map((vm) => (
          <div key={vm.id} className={styles.visitModelCardWrap}>
            {vm.badge && (
              <div className={styles.visitModelBadge}>{vm.badge}</div>
            )}
            <div
              className={
                selected === vm.id
                  ? styles.visitModelCardActive
                  : styles.visitModelCard
              }
              onClick={() => setSelected(vm.id)}
            >
              {/* <span className={styles.visitModelEmoji}>{vm.emoji}</span> */}
              {vm.type === "image" ? (
                <img
                  src={vm.icon}
                  alt={vm.label}
                  className={styles.chatImageInVM}
                />
              ) : (
                <span className={styles.visitModelEmoji}>
                  {vm.icon}
                </span>
              )}
              <div className={styles.visitModelLabel}>{vm.label}</div>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.visitModelHint}>
        We recommend a <strong>video consultation</strong> for faster access to care.
      </div>

      <button
        className={styles.visitModelContinueBtn}
        onClick={() => onSelect(selected)}
      >
        Continue →
      </button>
    </div>
  );
}
